export const reviews = [
  {
    id: '1',
    author: { name: '吃瓜群众小王', avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20person%20casual%20portrait%2C%20friendly%20smile%2C%20clean%20studio%20background%2C%20warm%20natural%20lighting%2C%20approachable%20look&width=120&height=120&seq=review-avatar-01&orientation=squarish' },
    content: '每天上班第一件事就是打开吃瓜每日榜单，十分钟把今天的热点全刷完，比刷微博效率高太多了！而且排名很客观，不太会被水军带节奏。',
    rating: 5
  },
  {
    id: '2',
    author: { name: '八卦小能手', avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20woman%20portrait%2C%20stylish%20casual%20look%2C%20warm%20smile%2C%20clean%20light%20background%2C%20natural%20lighting%2C%20friendly%20expression&width=120&height=120&seq=review-avatar-02&orientation=squarish' },
    content: '作为资深八卦爱好者，我愿称吃瓜每日榜单为全网最专业的吃瓜平台。选题有深度，不是随便抄来抄去的那种，编辑团队是真的懂行。',
    rating: 5
  },
  {
    id: '3',
    author: { name: '科技宅阿明', avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20man%20with%20glasses%2C%20tech%20casual%20style%2C%20friendly%20portrait%2C%20clean%20background%2C%20warm%20studio%20lighting&width=120&height=120&seq=review-avatar-03&orientation=squarish' },
    content: '界面简洁好看，没有乱七八糟的广告弹窗，这点太加分了。资讯更新速度也很快，经常比热搜榜还要快一步，真的有点东西。',
    rating: 4
  },
  {
    id: '4',
    author: { name: '追剧少女小雪', avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20girl%20portrait%2C%20fresh%20casual%20style%2C%20bright%20smile%2C%20clean%20soft%20background%2C%20warm%20natural%20light%2C%20youthful%20vibe&width=120&height=120&seq=review-avatar-04&orientation=squarish' },
    content: '影视板块是宝藏！新剧上线第一时间就有深度分析，比我自己到处搜剧评方便多了。还有那些幕后故事，真的太好磕了！',
    rating: 5
  }
];